import React, { useState, useEffect } from 'react'
import { getDataURL } from 'api/GetURLDocument/getURL'
import { getCookie } from 'helper/cookie'
import { EyeOutlined } from '@ant-design/icons'
import { Image } from 'antd'
import { getFileSecurityFromApi } from 'api/OpenFile'

const getURL = (props) => {
  const {
    project_id,
    id_document,
    type,
    getURL,
    setGetURL,
    setLoadingGetURL,
    dataFile,
    state,
  } = props

  const token = getCookie('access_token_admin')
  const [selectFile, setSelectFile] = useState()

  const getFileSecurityByUrl = async (url) => {
    await getFileSecurityFromApi({ url, token }).then((response) => {
      const { data } = response
      if (type === 'preview') {
        const blobUrl = URL.createObjectURL(data)
        window.open(blobUrl, '_blank')
      } else {
        const href = window.URL.createObjectURL(response.data)
        const anchorElement = document.createElement('a')
        anchorElement.href = href
        anchorElement.download = dataFile.title
        document.body.appendChild(anchorElement)
        anchorElement.click()
        document.body.removeChild(anchorElement)
        window.URL.revokeObjectURL(href)
      }
    })
  }

  const getResutURL = async () => {
    setLoadingGetURL(true)
    setSelectFile()
    getDataURL({
      id_document: id_document,
      project_id: project_id,
      token: token,
    })
      .then(async (response) => {
        const { status, data, error } = response
        if (error) {
          return true
        }
        if (status === 200) {
          if (type == 'preview') {
            setSelectFile(data.viewpath)
            let realFile = ''
            if (state == 'Overview') {
              realFile = dataFile.title
            } else {
              realFile = dataFile.filename
            }
            let typeFile = realFile.split('.')
            if (
              ['jpg', 'jpeg', 'png', 'JPG', 'JPEG', 'PNG'].includes(
                typeFile[typeFile.length - 1],
              )
            ) {
              const url = data.viewpath
              getFileSecurityByUrl(url)
              // document.getElementById('ShowImage').click()
            } else {
              const url = data.viewpath
              getFileSecurityByUrl(url)
              // window.open(data.viewpath, '_blank')
            }
          } else {
            const url = data.downloadpath
            getFileSecurityByUrl(url)
            // window.open(data.downloadpath, '_blank')
          }
          setGetURL(false)
          setLoadingGetURL(false)
        } else {
          setLoadingGetURL(false)
          return true
        }
      })
      .catch((error) => {
        console.error(error)
      })
  }

  useEffect(() => {
    if (getURL == true) {
      getResutURL()
    }
  }, [getURL])

  return (
    <Image
      hidden={true}
      id='ShowImage'
      prefix={<EyeOutlined />}
      placeholder={<EyeOutlined />}
      src={selectFile}
      preview={true}
      style={{ cursor: 'pointer' }}
    />
  )
}
export default getURL
